import { createFeatureSelector, createSelector } from "@ngrx/store";
import * as fromIbge from "../reducers/ibge.reducer";

export const selectIbgeState = createFeatureSelector<fromIbge.State>(
  fromIbge.ibgeFeatureKey
);

export const selectStates = createSelector(
  selectIbgeState,
  (state) => state.states
);

export const selectCities = (cacheKey: string) =>
  createSelector(selectIbgeState, (state) => state.cities[cacheKey] || []);
